module.exports = __webpack_public_path__ + "img/waiting.577ebfff.svg";